<template>
  <div>
    <div
      class="venue-title-bar"
      :style="pageTitleBar"
    >
      <div class="venue-title">
        MULTIPLE EVENTS
      </div>

      <div
        v-if="uploadedImageName"
        class="venue-image"
      >
        <img
          :src="uploadedImagePath"
          alt=""
        >
      </div>

      <div class="the-time">
        {{ theTime }}
      </div>
    </div>

    <table style="width: 100%;">
      <tr>
        <td
          style="width: 50%;"
          class="block-one"
        >
          <MultiScreenSection :quadrant="1" />
        </td>

        <td
          style="width: 50%;"
          class="block-two"
        >
          <MultiScreenSection :quadrant="2" />
        </td>
      </tr>

      <tr>
        <td
          style="width: 50%;"
          class="block-three"
        >
          <MultiScreenSection :quadrant="3" />
        </td>

        <td
          style="width: 50%;"
          class="block-four"
        >
          <MultiScreenSection :quadrant="4" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from 'moment';

import MultiScreenSection from '@/components/MultiScreenSection';

export default {
  name: 'Four',
  components: {
    MultiScreenSection
  },
  data() {
    return {
      theTime: ''
    };
  },
  computed: {
    pageTitleBar() {
      return this.$store.getters.pageTitleBar;
    },
    uploadedImagePath() {
      return `${this.$store.state.webUrl}/uploads/${this.$store.state.screenConfig.uploadedImageName}`;
    },
    uploadedImageName() {
      return this.$store.state.screenConfig.uploadedImageName;
    }
  },
  created() {
    setInterval(() => {
      this.theTime = moment.utc().add(2, 'hours').format('HH:mm:ss');
      this.$store.commit('updateSaNow', moment.utc().format('YYYY-MM-DDTHH:mm:ss') + '.000Z');
    }, 1000);
  }
};
</script>

<style>
.venue-title-bar {
  display: flex;
  flex-direction: row;
  height: 64px;
  font-size: 40px;
  font-weight: bold;
}
.venue-title {

  line-height: 64px;
  padding-left: 10px;
}
.venue-image {
  flex-grow: 1;
  align-content: flex-end;
  text-align: right;
}
.venue-image img {
  height: 64px;
}
.the-time {
  flex-grow: 1;
  align-content: flex-end;
  line-height: 64px;
  padding-right: 10px;
  width: 160px;
  text-align: right;
}
.multi-screen table {
  width: 100%;
}

.multi-screen table>tr>td {
  width: 50%;
}

.block-one {
  border-right: 4px solid #000;
}
.block-three {
  border-right: 4px solid #000;
}
</style>


// WEBPACK FOOTER //
// Four.vue?5d7f41f6